import { FormikProps } from 'formik';
import * as React from 'react';
import {
  IdentificationSubFormCore,
  IdentificationSummaryCore,
} from '../../components/Identification';
import { DirectDebitForm } from '../Form/Form';

interface IdentificationSectionProps {
  // formikProps: FormikProps<IdentificationParentForm>;
  formikProps: FormikProps<DirectDebitForm>;
  isEdit: boolean;
  isComplete: boolean;
  onNextClick: () => void;
  onEditClick: () => void;
}

export const IdentificationSectionCore: React.FC<IdentificationSectionProps> = ({
  formikProps,
  isEdit,
  isComplete,
  onNextClick,
  onEditClick,
}) => {
  const { identifyYourAccountForm } = formikProps.values;
  return (
    <>
      {isEdit && (
        <IdentificationSubFormCore
          formikProps={formikProps}
          isEdit={isEdit}
          onNextClick={onNextClick}
        />
      )}
      {!isEdit && (
        <IdentificationSummaryCore
          accountNumber={identifyYourAccountForm.accountNumber}
          dateOfBirth={identifyYourAccountForm.dob}
          firstName={identifyYourAccountForm.firstName}
          lastName={identifyYourAccountForm.lastName}
          showSummaryFields={isComplete}
          onEditClick={onEditClick}
        />
      )}
    </>
  );
};
